import React from 'react';
import 'bulma/css/bulma.min.css'; // Ensure Bulma CSS is imported

const ProgressBar = ({ completedLessons, totalLessons }) => {
  // Handle undefined or null values
  const safeCompletedLessons = completedLessons || 0;
  const safeTotalLessons = totalLessons || 1;
  const progressPercentage = (safeCompletedLessons / safeTotalLessons) * 100;

  return (
    <div className="progress-bar-container" style={{ width: '100%' }}>
      <progress className="progress is-warning" value={progressPercentage} max="100"></progress>
      <p className="has-text-centered has-text-warning has-text-weight-bold mb-3">
        {`${safeCompletedLessons} of ${safeTotalLessons} lessons in this course completed`}
      </p>
    </div>
  );
};

export default ProgressBar;
